import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core'
import { BehaviorSubject, Observable } from 'rxjs'
import { Router } from '@angular/router'
import { takeUntil } from 'rxjs/operators'

import { ChatModel } from '@shared/models/messenger/messenger.model'
import { MessengerService } from '@app/modules/client/messenger/services/messenger.service'
import { MessengerApiService } from '@app/modules/client/messenger/services/messenger-api.service'
import { AuthService } from '@app/modules/auth/auth.service'
import { DestroyService } from '@core/services/destroy.service'
import { PaginationData } from '@shared/models/pages-data.model'

@Component({
  selector: 'lin-chat-toolbar-list',
  templateUrl: './chat-toolbar-list.component.html',
  styleUrls: ['./chat-toolbar-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [DestroyService],
  standalone: false,
})
export class ChatToolbarListComponent implements OnInit {
  chatList: ChatModel[] = []
  isLoading$ = new BehaviorSubject<boolean>(false)

  @Input() isToolbar = true

  private page = 1
  private limit = 20
  private total

  constructor(
    public readonly messengerService: MessengerService,
    private readonly router: Router,
    private readonly messengerApiService: MessengerApiService,
    private readonly authService: AuthService,
    private readonly destroyService: DestroyService,
  ) {}

  ngOnInit(): void {
    this.getChatListData()
  }

  trackById(_, { id }: ChatModel): number {
    return id
  }

  scrollHandler(): void {
    if (this.page * this.limit >= this.total) return

    this.page = this.page + 1
    this.getChatListData()
  }

  private getChatListData(): void {
    const chatListDataSubscribe = ({ data, total, ...rest }: PaginationData<ChatModel[]>): void => {
      this.chatList = [...this.chatList, ...data]
      this.total = total
      this.messengerService.setUnreadCount(rest?.additionalFields?.totalUnreadCount || 0)
      this.isLoading$.next(false)
    }

    this.getChatList().subscribe(chatListDataSubscribe)
  }

  private getChatList = (): Observable<PaginationData<ChatModel[]>> => {
    this.isLoading$.next(true)

    return this.messengerApiService
      .getChatList({
        page: this.page,
        limit: this.limit,
        isUnread: 1,
      })
      .pipe(takeUntil(this.destroyService))
  }
}
